var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.crew.id || _vm.createMode)?_c('div',[_c('customer-edit',{attrs:{"crew":_vm.crew,"title":_vm.title},on:{"saved":_vm.updateCrew}})],1):_c('div',[_vm._v("Elemento no encontrado")])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/Catalogs/Crews/Update.vue